import { useEffect, useId } from 'react';
import { EyeIcon } from 'lucide-react';
import { KnowledgeBaseFormField } from '../KnowledgeBaseFormField';
import type { FormSpaceVisibilityProps } from './KnowledgeBaseFormSpaceVisibility.types';
import { useKBVisibilityOptions } from './useKBVisibilityOptions';
import { RadioCardGroup } from '@/shared/ui/RadioCardGroup';
import { useTranslation } from 'react-i18next';

export const KnowledgeBaseFormSpaceVisibility = ({
  spaceVisibility,
  setSpaceVisibility,
}: FormSpaceVisibilityProps) => {
  const { t } = useTranslation('knowledge');

  const fieldId = useId();
  const descriptionId = useId();
  const visibilityOptions = useKBVisibilityOptions();

  useEffect(() => {
    const defaultOption = visibilityOptions.find((option) => option.checkedByDefault);
    if (defaultOption && spaceVisibility == null) {
      setSpaceVisibility(defaultOption.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <KnowledgeBaseFormField
      icon={<EyeIcon />}
      title={t('knowledgeBases.knowledgeBaseFormSpaceVisibility.spaceVisibility')}
      description={t('knowledgeBases.knowledgeBaseFormSpaceVisibility.setTheSpaceVisibilityTo')}
      required
      fieldId={fieldId}
      descriptionId={descriptionId}
    >
      <RadioCardGroup
        aria-labelledby={`${fieldId}-label`}
        aria-describedby={descriptionId}
        options={visibilityOptions}
        value={spaceVisibility}
        onChange={setSpaceVisibility}
      />
    </KnowledgeBaseFormField>
  );
};

KnowledgeBaseFormSpaceVisibility.displayName = 'KnowledgeBaseFormSpaceVisibility';
